import React, { createContext, useContext, useMemo, useState } from "react";
import { profiles as baseProfiles } from "../User/UserData/data";

const ClientContext = createContext(null);

const baseDefaults = {
  type: "Organization",
  companyName: "",
  name: "",
  tradeName: "",
  taxOffice: "",
  taxNumber: "",
  owner: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  country: "",
  phone: "",
  website: "",
  vatNumber: "",
  gstNumber: "",
  clientGroups: [],
  currency: "",
  currencySymbol: "",
  labels: [],
  clientPM: "",
  partner: "",
  notes: "",
  disableOnlinePayment: false,
  status: "Active",
};

// ClientsPage’deki tohum veriyi yeni modele normalize ediyoruz
const seedClients = [
  {
    id: 1,
    name: "Digital Exchange",
    contact: "Digital Exchange",
    phone: "+905054538665",
    owner: "Ömer Sefa Demirci",
    groups: ["Key Account", "Best clients"],
    labels: ["US"],
    projects: 764,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
  {
    id: 2,
    name: "Kant",
    contact: "Hasibe Karataş",
    phone: "+90 531 689 61 63",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US"],
    projects: 5,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Inactive",
  },
  {
    id: 3,
    name: "Cuptyou",
    contact: "Uluç Alatlı",
    phone: "+905441099478",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US", "SETUP"],
    projects: 6,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
  {
    id: 4,
    name: "Digital Exchange",
    contact: "Digital Exchange",
    phone: "+905054538665",
    owner: "Ömer Sefa Demirci",
    groups: ["Key Account", "Best clients"],
    labels: ["US"],
    projects: 764,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
  {
    id: 5,
    name: "Kant",
    contact: "Hasibe Karataş",
    phone: "+90 531 689 61 63",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US"],
    projects: 5,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Inactive",
  },
  {
    id: 6,
    name: "Cuptyou",
    contact: "Uluç Alatlı",
    phone: "+905441099478",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US", "SETUP"],
    projects: 6,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
  {
    id: 7,
    name: "Digital Exchange",
    contact: "Digital Exchange",
    phone: "+905054538665",
    owner: "Ömer Sefa Demirci",
    groups: ["Key Account", "Best clients"],
    labels: ["US"],
    projects: 764,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
  {
    id: 8,
    name: "Kant",
    contact: "Hasibe Karataş",
    phone: "+90 531 689 61 63",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US"],
    projects: 5,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Inactive",
  },
  {
    id: 9,
    name: "Cuptyou",
    contact: "Uluç Alatlı",
    phone: "+905441099478",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US", "SETUP"],
    projects: 6,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
  {
    id: 10,
    name: "Digital Exchange",
    contact: "Digital Exchange",
    phone: "+905054538665",
    owner: "Ömer Sefa Demirci",
    groups: ["Key Account", "Best clients"],
    labels: ["US"],
    projects: 764,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
  {
    id: 11,
    name: "Kant",
    contact: "Hasibe Karataş",
    phone: "+90 531 689 61 63",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US"],
    projects: 5,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Inactive",
  },
  {
    id: 12,
    name: "Cuptyou",
    contact: "Uluç Alatlı",
    phone: "+905441099478",
    owner: "İpek Tosun",
    groups: ["Standart"],
    labels: ["US", "SETUP"],
    projects: 6,
    totalInvoiced: "₺0,00",
    paymentReceived: "₺0,00",
    due: "₺0,00",
    status: "Active",
  },
];

const normalizeClient = (client) => {
  const baseName = client.companyName || client.name || client.contact || "";
  return {
    ...baseDefaults,
    ...client,
    type: client.type || "Organization",
    companyName: client.companyName || baseName,
    name: client.name || baseName,
    clientGroups: client.clientGroups || client.groups || [],
    labels: client.labels || [],
    notes: client.notes || "",
    disableOnlinePayment: Boolean(client.disableOnlinePayment),
    status: client.status || "Active",
  };
};

export const useClients = () => {
  const ctx = useContext(ClientContext);
  if (!ctx) throw new Error("useClients must be used within <ClientProvider>");
  return ctx;
};

const ClientProvider = ({ children }) => {
  const [clients, setClients] = useState(seedClients.map(normalizeClient));
  const [extraProfiles, setExtraProfiles] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  const buildClientProfile = (client) => {
    const id = client.id || `c_${Math.floor(Math.random() * 1000000)}`;
    const name =
      client.companyName ||
      client.name ||
      client.tradeName ||
      client.contact ||
      `Client ${id}`;
    return {
      id,
      type: "client",
      companyName: name,
      overview: {
        name,
        firstName: client.firstName || name,
        lastName: client.lastName || "",
        email: client.email || "",
        role: "Client",
        avatar: client.avatar || "https://i.pravatar.cc/160?img=12",
      },
      metrics: client.metrics || {},
      generalInfo: {
        phone: { countryCode: "", nationalNumber: client.phone || "" },
        mailingAddress: client.email || "",
      },
      account: { email: client.email || "", role: "Client" },
    };
  };

  const addClient = (data) => {
    const id = data.id || Math.floor(Math.random() * 1000000);
    const normalized = normalizeClient({ ...data, id });
    setClients((prev) => [...prev, normalized]);
    setExtraProfiles((prev) => [...prev, buildClientProfile(normalized)]);
  };

  const updateClient = (data) => {
    const normalized = normalizeClient(data);
    setClients((prev) =>
      prev.map((c) => (c.id === normalized.id ? normalized : c))
    );
    setExtraProfiles((prev) =>
      prev.map((p) => (p.id === normalized.id ? buildClientProfile(normalized) : p))
    );
  };

  const deleteClient = (id) => {
    setClients((prev) => prev.filter((c) => c.id !== id));
    setExtraProfiles((prev) => prev.filter((p) => p.id !== id));
  };

  const profilesCombined = useMemo(
    () => [...baseProfiles, ...extraProfiles],
    [extraProfiles]
  );

  const value = useMemo(
    () => ({
      clients,
      setClients,
      selectedClient,
      setSelectedClient,
      addClient,
      updateClient,
      deleteClient,
      users: profilesCombined.filter((p) => p.type === "user"),
      profilesCombined,
    }),
    [clients, selectedClient, profilesCombined]
  );

  return <ClientContext.Provider value={value}>{children}</ClientContext.Provider>;
};

export default ClientProvider;
